import { useForm, type FormApi } from '@tanstack/react-form';
import { createContext, useContext, type ReactNode } from 'react';

const FormContext = createContext<ReturnType<typeof useForm> | null>(null);

interface FormProviderProps {
  children: React.ReactNode;
  form: ReturnType<typeof useForm<any, any>>;
}

export const FormProvider = ({ children, form }: FormProviderProps) => {
  return <FormContext.Provider value={form}>{children}</FormContext.Provider>;
};

export const useFormContext = () => {
  const form = useContext(FormContext);

  if (form === null) {
    throw new Error('useFormContext must be used within a provider');
  }

  return form;
};
